export const colors = {
  primary: "#003865",
  secondary: "#00C1D4",
  white: {
    main: "#fff",
    gray: "#f7f7f7",
  },
  black: {
    main: "#000000",
  },
  gray: {
    light: "#f7f7f7",
    main: "#8f8f8f",
    dark: "#525252",
    medium: "#d9d8d6",
    textDark: "#666666",
    textLight: "#8D8D8D",
  },
  red: {
    light: "#ED4E4E",
    main: "#d60e00",
    dark: "8a0a01",
  },
  green: {
    light: "#ebebeb",
    main: "#09B83A",
    dark: "#484646",
    secondary: "#6FB76F",
  },
  yellow: {
    main: "#FFB711",
    secondary: "#FFDB99",
  },
  blue: {
    financial: "#2C8B9E",
  },
  orange: {
    main: "#F79A3E",
    light: "#ffb81c",
    secondary: "#FFC64A",
    title: "#FFC649",
  },
};
